import produce from "immer";
import axios from "axios";
import strings from "../../../res/strings";
import { setAppProcessing, setAppSuccess, setAppError } from "../../common";

export const UPLOAD_IMAGES = "image/UPLOAD_IMAGES";
export const DELETE_IMAGE = "image/DELETE_IMAGE";

const UPLOAD_IMAGES_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const DELETE_IMAGE_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};

const initialState = {};

export default (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case DELETE_IMAGE: {
        break;
      }

      default: {
        break;
      }
    }
  });

export const uploadImages = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "image.uploadImages",
          message: strings.lib_common_state_error,
        }
      )
    );

    const data = new FormData();
    data.append("auth_token", values.auth_token);
    data.append("parent_object_id", values.parent_object_id);
    data.append(
      "parent_content_type_app_label",
      values.parent_content_type_app_label
    );
    data.append("parent_content_type_model", values.parent_content_type_model);

    data.append("num_images", values.images.length);
    values.images.forEach((image, index) => {
      data.append(`image_${index}`, image);
    });

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LIB_FILE_UPLOAD_IMAGES,
        data
      )
      .then((response) => {
        dispatch({ type: UPLOAD_IMAGES });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? { context: "images.uploadImages" },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = UPLOAD_IMAGES_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "images.uploadImages",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const deleteImage = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "image.deleteImage",
          message: strings.lib_common_state_error,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LIB_FILE_DELETE_IMAGE,
        values
      )
      .then((response) => {
        dispatch({ type: DELETE_IMAGE });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(values, response)
              : successState ?? {
                  context: "image.deleteImage",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = DELETE_IMAGE_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "image.deleteImage",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};
